// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  main {
    flex: 1 1;
    padding: 60px 0 0 0; /* Added top padding equal to navbar height */
    background-color: #8ECCF5;
    margin: 0;
    width: 100%;
    min-height: 100vh;
  }

  .feedback-footer {
    text-align: center;
    padding: 10px 0;
    background-color: #8ECCF5;
    font-family: 'Inter', sans-serif;;
  }

  .feedback-footer a {
    color: #0047AB;
    text-decoration: none;
    font-size: 0.9rem;
  }

  .feedback-footer a:hover {
    text-decoration: underline;
  }`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,mBAAmB,EAAE,6CAA6C;IAClE,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":[".layout {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n  \n  main {\n    flex: 1;\n    padding: 60px 0 0 0; /* Added top padding equal to navbar height */\n    background-color: #8ECCF5;\n    margin: 0;\n    width: 100%;\n    min-height: 100vh;\n  }\n\n  .feedback-footer {\n    text-align: center;\n    padding: 10px 0;\n    background-color: #8ECCF5;\n    font-family: 'Inter', sans-serif;;\n  }\n\n  .feedback-footer a {\n    color: #0047AB;\n    text-decoration: none;\n    font-size: 0.9rem;\n  }\n\n  .feedback-footer a:hover {\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
